module.exports = "<md-dialog layout=\"column\" layout-align=\"start stretch\">\n\t<md-dialog-content class=\"md-dialog-content\">\n\t\t<h2 class=\"md-title\">{{vm.title}}</h2>\n\t\t<div>{{vm.detail}}</div>\n\t</md-dialog-content>\n\t<md-dialog-actions layout=\"row\">\n\t\t<md-button ng-click=\"vm.dismiss(false)\">{{vm.cancelButtonText}}</md-button>\n\t\t<md-button ng-click=\"vm.dismiss(true)\" class=\"md-primary\">{{vm.confirmButtonText}}</md-button>\n\t</md-dialog-actions>    \n</md-dialog>";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase/components/confirmDialog/confirmDialog.template.html
// module id = 1106
// module chunks = 0